module.exports = __webpack_public_path__ + "static/julie-41dd3ef053988f44a552c7b814555c64.jpg";